const RBAC_API_BASE =
  process.env.REACT_APP_RBAC_API_URL ||
  "https://sbwnv46fcd.execute-api.us-east-1.amazonaws.com/dev";


function getToken() {
  return (
    localStorage.getItem("idToken") ||
    localStorage.getItem("accessToken") ||
    ""
  );
}


async function request(path, options = {}) {

  const token = getToken();

  if (!token) {
    throw new Error("RBAC_TOKEN_NOT_FOUND");
  }


  const response =
    await fetch(
      `${RBAC_API_BASE}${path}`,
      {
        ...options,

        headers: {
          "Content-Type": "application/json",

          Authorization:
            `Bearer ${token}`,

          ...(options.headers || {}),
        },

        cache: "no-store",
      }
    );


  let body = null;


  try {
    body = await response.json();
  } catch {
    body = null;
  }


  if (!response.ok) {

    const error =
      new Error(
        body?.message ||
        `RBAC_HTTP_${response.status}`
      );

    error.status = response.status;
    error.body = body;

    throw error;
  }


  return body;
}


export function fetchRbacPolicy() {

  return request(
    "/rbac/policy",
    {
      method: "GET",
    }
  );
}


export function fetchRbacMe() {

  return request(
    "/rbac/me",
    {
      method: "GET",
    }
  );
}


export function putRbacPolicy(roles) {

  return request(
    "/rbac/policy",
    {
      method: "PUT",

      body:
        JSON.stringify({
          roles,
        }),
    }
  );
}


export function fetchRbacUsers({
  limit = 50,
  cursor = null,
} = {}) {

  const params =
    new URLSearchParams();


  params.set(
    "limit",
    String(limit)
  );


  if (cursor) {

    params.set(
      "cursor",
      cursor
    );
  }


  return request(
    `/rbac/users?${params.toString()}`,
    {
      method: "GET",
    }
  );
}


export function createRbacUser({
  email,
  name,
  role,
}) {

  return request(
    "/rbac/users",
    {
      method: "POST",

      body:
        JSON.stringify({
          email,
          name,
          role,
        }),
    }
  );
}


export function changeRbacUserRole(
  sub,
  role
) {

  return request(
    `/rbac/users/${encodeURIComponent(sub)}/role`,
    {
      method: "PUT",

      body:
        JSON.stringify({
          role,
        }),
    }
  );
}


export function fetchRbacRoles() {

  return request(
    "/rbac/roles",
    {
      method: "GET",
    }
  );
}


export function putRbacRole(
  role,
  payload
) {

  return request(
    `/rbac/roles/${encodeURIComponent(role)}`,
    {
      method: "PUT",

      body:
        JSON.stringify(payload),
    }
  );
}


export {
  RBAC_API_BASE,
};